import request from "@/service";

// 查询调训分页
export function getTopicLectureList(params) {
  return request({
    url: `/study/topicLecture/page`,
    method: "post",
    data: params
  });
}

// 专题讲座导入
export function importTopicLecture(params) {
  return request({
    url: "/study/topicLecture/import",
    method: "post",
    headers: {
      "Content-Type":
        "multipart/form-data; boundary=----WebKitFormBoundaryyJzVStTyqSc9B1Ut"
    },
    data: params
  });
}
// 删除专题讲座
export function deleteTopicLecture(params) {
  return request({
    url: `/study/topicLecture/delete`,
    method: "post",
    data: params
  });
}

// 专题讲座申报分页列表
export function getDeclarePage(params) {
  return request({
    url: `/study/topicLecture/declarePage`,
    method: "post",
    data: params
  });
}

// 专题讲座新增申报
export function addDeclare(data) {
  return request({
    url: `/study/topicLecture/addDeclare`,
    method: "post",
    data
  });
}

// 查询专题讲座申报审核详情
export function queryDeclare(data) {
  return request({
    url: `/study/topicLecture/queryDeclare`,
    method: "get",
    params: data
  });
}

// 查询部门组织树（名字模糊查询)
export function queryDeptTreeByName(data) {
  return request({
    url: `/user/sys/dept/deptTreeByName`,
    method: "get",
    params: data
  })
}

// 专题讲座审核分页列表
export function specialConditionPage(params) {
  return request({
    url: `/study/topicLecture/specialConditionPage`,
    method: "post",
    data: params
  });
}

// 专题讲座审核--批量审核
export function specialBatchAudit(params) {
  return request({
    url: `/study/topicLecture/specialBatchAudit`,
    method: "post",
    data: params
  });
}

// 其他集中培训申报
export function getOtherTrainPage(params) {
  return request({
    url: `/study/topicLecture/otherTrainDeclarePage`,
    method: "post",
    data: params
  });
}

// 其他集中培训申报新增
export function addOtherTrainDeclare(data) {
  return request({
    url: `/study/topicLecture/addOtherTrainDeclare`,
    method: "post",
    data
  });
}
// 其他集中培训申报详情
export function queryOtherTrainDeclareInfo(uuid) {
  return request({
    url: `/study/topicLecture/queryDeclareInfo?uuid=${uuid}`,
    method: "get",
  })
}
// 其他集中培训审核列表
export function getOtherTrainAuditPage(data) {
  return request({
    url: `/study/topicLecture/otherTrainAuditPage`,
    method: "post",
    data
  });
}

// 其他集中培训批量/单个审核接口
export function otherTrainBatchAudit(data) {
  return request({
    url: `/study/topicLecture/otherTrainBatchAudit`,
    method: "post",
    data
  });
}

// 获取集中培训业务短信发送人和短信内容
export function queryTrainingMessage(data) {
  return request({
    url: `/study/topicLecture/queryTrainingMessage`,
    method: "get",
    params: data
  })
}

// 查询专题讲座申报-获取学时
export function getIntervalCredit(data) {
  return request({
    url: `/study/topicLecture/getIntervalCredit`,
    method: "get",
    params: data
  });
}

export function getTopicLecturePageNew(data) {
  return request({
    url: `/study/topicLecture/pageNew`,
    method: "post",
    data
  });
}

export function getTopicLectureSearchList(data) {
  return request({
    url: `/study/topicLecture/searchList`,
    method: "post",
    data
  });
}

export function getTopicLectureDetailPage(data) {
  return request({
    url: `/study/topicLecture/detailPage`,
    method: "post",
    data
  });
}


export function getTopicLectureUserHour(data) {
  return request({
    url: `/study/topicLecture/userHour`,
    method: "post",
    data
  });
}





